import { Box } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";

export function OrdersPage(props) {
  return (
    <React.Fragment>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Outlet />
      </Box>
    </React.Fragment>
  );
}
